import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import '../components/AboutUsPage.css';

export default function OurTeamPage() {
    const [site, setSite] = useState(null);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([api.get('/content/site'), api.get('/content/aboutUs')])
            .then(([siteRes, aboutRes]) => {
                setSite(siteRes.data);
                setData(aboutRes.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    if (loading) return <div className="loading-screen"><div className="spinner"></div><p>Loading...</p></div>;
    if (!site || !data) return null;

    const { executiveCommittee, advisoryBoard } = data;

    return (
        <div className="App">
            <MetaTags
                title="Our Team | Melbourne Nepalese Community West"
                description="Meet the leadership, executive committee, and advisory board of Melbourne Nepalese Community West (MNCW)."
                url="https://mncw.org.au/team"
                image="https://mncw.org.au/assets/img/logo.jpg"
                type="website"
            />
            <Header data={site} />
            <section className="about-us-page section" style={{ marginTop: 128 }}>
                <div className="container">

                    {/* Leadership Team */}
                    <div className="committee-section">
                        <h2>Leadership Team</h2>
                        <p className="committee-intro">{executiveCommittee.intro}</p>
                        <div className="leadership-grid">
                            {executiveCommittee.leadership.map((member, i) => (
                                <div key={i} className="team-member leadership-member">
                                    <div className="member-photo">
                                        <img src={member.photo} alt={member.name} />
                                        <div className="member-overlay"></div>
                                    </div>
                                    <div className="member-info">
                                        <h4>{member.name}</h4>
                                        <p className="member-position">{member.position}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Executive Members */}
                    <div className="committee-section">
                        <h2>Executive Members</h2>
                        <div className="members-grid">
                            {executiveCommittee.members.map((member, i) => (
                                <div key={i} className="team-member">
                                    <div className="member-photo">
                                        <img src={member.photo} alt={member.name} />
                                        <div className="member-overlay"></div>
                                    </div>
                                    <div className="member-info">
                                        <h4>{member.name}</h4>
                                        <p className="member-position">{member.position}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Advisory Board */}
                    <div className="advisory-section">
                        <h2>{advisoryBoard.title}</h2>
                        <p className="advisory-intro">{advisoryBoard.intro}</p>
                        <div className="advisory-grid">
                            {advisoryBoard.members.map((member, i) => (
                                <div key={i} className="team-member advisor-member">
                                    <div className="member-photo">
                                        <img src={member.photo} alt={member.name} />
                                        <div className="member-overlay gold-overlay"></div>
                                    </div>
                                    <div className="member-info">
                                        <h4>{member.name}</h4>
                                        <p className="member-position">{member.designation}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
            <Footer data={site} />
        </div>
    );
}
